module.exports = __webpack_public_path__ + "montserrat-okta-light-webfont.6225f3ca44b83090833064727a09cc95.woff";